import { Button } from "antd";
import {
  AuthorizationList,
  CanAccess,
} from "../../../components/template/authorization/Authorization";

export const initFilterInput = {
  searchName: "",
  page: 1,
  pageSize: 10,
};

export const renderColumns = (handleUpdate, handleDelete) => {
  return [
    {
      dataIndex: "accountNumber",
      key: "accountNumber",
      title: "Nomor Rekening",
    },
    // {
    //   dataIndex: "cardNumber",
    //   key: "cardNumber",
    //   title: "Nomor Kartu",
    // },
    {
      dataIndex: "accountName",
      key: "accountName",
      title: "Nama Rekening",
    },
    {
      dataIndex: "bankName",
      key: "bankName",
      title: "Nama Bank",
    },
    // {
    //   dataIndex: "accountPicture",
    //   key: "accountPicture",
    //   title: "Buku Rekening",
    // },
    {
      dataIndex: "action",
      key: "action",
      title: "Aksi",
      width: "7%",
      render: (_, record) => (
        <div style={{ gap: "10px" }}>
          <CanAccess
            role={AuthorizationList.update_bank}
            yes={
              <Button
                style={{ width: 80, borderRadius: 4 }}
                variant="primary"
                className="btn-action btn-detail"
                onClick={() => handleUpdate(record)}
              >
                Ubah
              </Button>
            }
          />
          <CanAccess
            role={AuthorizationList.delete_bank}
            yes={
              <Button
                style={{ width: 80, borderRadius: 4 }}
                variant="danger"
                type="primary"
                className="btn-action btn-delete mt-1"
                danger
                onClick={() => handleDelete(record)}
              >
                Hapus
              </Button>
            }
          />
        </div>
      ),
    },
  ];
};
